<template lang="html">
    <div>
        <div v-if="ota">

            <div class="bg-blue-pale p-2 fs-small">
                Please note that you need to have active products on GYG in order to connect with Pluralo. <a class="darkest underlined" :href="otaLink" target="_blank">Sign up with GetYourGuide</a> if you haven't already.
            </div>

            <list class="mt-4" :header="productListHeader" :body="productListBody" :rows="products" ></list>

        </div>
    </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import List from '@/tools/list/baseList'

export default {
    props: {
        ota:{
            type: Object
        }
    },
    computed: {
        ...mapGetters([
            'getProducts',
            'getProductsLabels',
        ]),
        otaLink: function () {
            return this.ota.integration.otaLink
        },
        products: function () {
            return this.getProducts
        },
        productListHeader: function() {
            return {
                selection: {
                    active: false,
                    event: (event) => {}
                },
                list: {
                    id: 'ID',
                    name: 'Name',
                    code: 'Code',
                    category: 'Category',
                },
            };
        },
        productListBody: function () {
            return {
                selection: {
                    active: false,
                    event: (event) => {}
                },
                customCells: {
                    id: this.formatId,
                    name: this.formatName,
                    category: this.formatCategory,
                    active: this.formatActive
                },
                customRowEvent: null,
            }
        },
    },
    methods: {
        formatId: function(item) {
            return item.externalBookingSystemCode
        },
        formatName: function(item) {
            return '<div class="bold">' + item.name + '</div>';
        },
        formatCategory: function(item) {
            return (item.categoryList.length > 0) ? item.categoryList.map(i => i.name).join(', ') : '-';
        },
        formatActive: function(item) {
            return (item.active) ? 'Yes' : 'No';
        },
    },
    components: {
        List
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// otaIntegration.vue?82f24b16